/* --------------------------------------------------------------------------
	Topic Media
-------------------------------------------------------------------------- */
"use strict";
import 'fastdom';
var $ = jQuery;
var $media_trigger;

function initMediaModal() {
    $media_trigger = $('js-media-click-target');
    
    
    $media_trigger.on('click', mediaModal)
    
}

function dismissModal(clickOption) {
	document.body.setAttribute('aria-hidden', 'false');
	
	// document.getElementById('media-modal').setAttribute('aria-hidden', 'true');
	window.dataLayer = window.dataLayer || [];
	window.dataLayer.push({
		event: 'givingdaydismissed',
		// outboundLinkUrl: next_btn.href,
		clickOption: clickOption
	});
	document.getElementsByClassName('media-modal')[0].remove();
}
function mediaModal(url) {
    document.body.setAttribute('aria-hidden', 'false');
    var modal = document.createElement('div');
	modal.setAttribute('class', 'outbound-container media-modal video_overlay_container');
    modal.setAttribute('aria-hidden', 'true');
    modal.setAttribute('style', 'display: flex;');
    var section = document.createElement('section');
    section.setAttribute('id', 'outbound');
    var inside_container = document.createElement('div');
    inside_container.setAttribute('class', 'inside-container');
    inside_container.setAttribute('style', 'position: relative;');
    inside_container.innerHTML = '<div id="video-overlay-container"><iframe width="560" height="315" src="'+ url +'" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe><a href="#" class="close-btn" title="Close" style="text-decoration: none; font-size: 2rem; position: absolute; right:-40px; top: -40px; color: #FFF;" onclick="dismissModal(\'click x\');">&times;</a></div>'
    var desc = document.createElement('div');
    desc.setAttribute('class', 'modal-media-description');
    desc.innerHTML = '<p class="sr-only" id="modal-video-title-1">A video is being shown</p><section class="typography">Join the worldwide Adelphi community today as we come together to transform lives by supporting important student initiatives—more important than ever due to the pandemic.</section>';
    desc.innerHTML += '<a class="video_overlay_link" title="Donate to Adelphi Giving Day" href="https://adelphi.imodules.com/s/1907/19/home.aspx?sid=1907&gid=2&pgid=467" rel="noopener" target="_blank" aria-label="Donate to Adelphi Giving Day" onclick="dismissModal(\'make gift\');">Make a Gift</a> <a class="btn-secondary cancel-btn" title="No Thanks" href="#" aria-label="No Thanks" onclick="dismissModal(\'no thanks\');">Exit</a>  </section>'
    section.appendChild(inside_container);
    section.appendChild(desc);
    modal.appendChild(section);
	// modal.innerHTML = '<iframe width="560" height="315" src="https://www.youtube.com/embed/shIDDj2zuiU" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>';
	document.getElementsByTagName('body')[0].appendChild(modal);
    var close = document.getElementsByClassName('close-btn')[0];

	close.addEventListener('click', function(e) {
		e.preventDefault();
		dismissModal(modal, "close x");
	});

	document.addEventListener('keyup', function(e) {
		if (e.key === 'Escape') {
			dismissModal('esc key');
		}
	});

	
}

$(initMediaModal);